<template>
  <v-alert
    v-if="visible"
    type="info"
    density="compact"
    variant="tonal"
    class="mb-3"
  >
    <div class="d-flex align-center flex-wrap" style="gap: 8px;">
      <span>{{ $t('myassets.running_on_selection', { count: selectionCount }) }}</span>
      <v-btn
        size="x-small"
        variant="text"
        color="primary"
        @click="$emit('clear-selection')"
      >
        {{ $t('myassets.clear_selection') }}
      </v-btn>
    </div>
    <div class="text-caption mt-1">{{ $t('myassets.clear_selection_hint') }}</div>
  </v-alert>
</template>

<script>
export default {
  name: 'MyAssetsRunTargetBanner',
  props: {
    useSelection: { type: Boolean, default: false },
    selectionCount: { type: Number, default: 0 },
  },
  computed: {
    visible() {
      return this.useSelection && this.selectionCount > 0;
    },
  },
};
</script>
